<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="max-height: calc(100% - 60px);padding-top:20px;margin:0 20px;overflow-y: auto">
      <el-table :data="showTable" style="width: 100%" highlight-current-row ref="singleTable" border>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="p_name" label="服务对象" min-width="70" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.device">{{scope.row.device.p_name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="楼栋/楼层/房间" min-width="120" align="center">
          <template slot-scope="scope">
<!--            <span>{{scope.row.build_name}} / {{scope.row.floor_name}} / {{scope.row.home_room}}</span>-->
            <span v-if="scope.row.device">{{scope.row.device.build_name}} / {{scope.row.device.floor_name}} / {{scope.row.device.home_room}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="事件类型" min-width="110">
          <template slot-scope="scope">
            <img style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImgAlarm(scope.row.alarmtype)">
            <span>{{getAType(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="time" label="事件时间" min-width="140"></el-table-column>
        <el-table-column align="center" label="设备编号" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.device">{{scope.row.device.deviceid}}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备类型" min-width="126" align="center">
          <template slot-scope="scope">
            <img v-if="scope.row.device && (scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein')" style="vertical-align: sub;width: 20px;height: 20px" :src="getTypeImg(scope.row.device.devicetype)">
            <span v-if="scope.row.device && (scope.row.alarmtype !== 'birthday' || scope.row.alarmtype !== 'phonein')">{{getDeviceType(scope.row.device.devicetype)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="设备号码" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.device">{{getDevicePhone(scope.row.device)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="安装位置"
          min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.device">
              <span>{{scope.row.device.h_installlocation}}</span>
              <span>{{scope.row.device.o_installlocation}}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button size="small" type="warning" :disabled="!(!scope.row.buttondisable)" @click="handleChangeNew(scope.row)">现在处理</el-button>
          </template>
        </el-table-column>
        <el-table-column label="处理信息"  align="center" min-width="120">
          <template slot-scope="scope">
            <div style="color: #e64d00" v-if="scope.row.handleuesrname === '未处理'">
              <img src="../../assets/handlealarm/event_icon_not.png" style="vertical-align: middle;width: 16px">
              <strong>{{scope.row.handleuesrname}}</strong>
            </div>
            <div style="color: #00bfff" v-else-if="scope.row.handleuesrname === '继续处理'">
              <img src="../../assets/handlealarm/event_icon_continue.png" style="vertical-align: middle;width: 16px">
              <strong>{{scope.row.handleuesrname}}</strong>
            </div>
            <div style="color: #e5a015" v-else>
              <img src="../../assets/handlealarm/event_icon_major.png" style="vertical-align: middle;width: 16px">
              <strong>{{scope.row.handleuesrname}}</strong>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: center;margin-top: 10px;height: 40px;">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog top="5vh" :visible.sync="handleAlarmShow" v-if="handleAlarmShow" width="900px"
               :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false" class="alarm-detail">
      <open-handle-alarm :handleAlarmRow="changeRow"  @getFatherHandle="getFatherHandle"></open-handle-alarm>
    </el-dialog>
  </div>
</template>

<script>
import {queryunhanlealarm} from '../../api/handlealarm'
import {querydevicebydids} from '../../api/device'
import {sendSub} from '../../mq'
import openHandleAlarm from './components/openHandleAlarm'
export default {
  name: 'dealAlarm',
  components: {openHandleAlarm},
  data () {
    return {
      dids: [],
      devices: [],
      isDevice: true,
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      imgIconAlarm: [],
      imgIcon: [],
      handleAlarmShow: false,
      changeRow: {
        isPhonein: false,
        oldPerson: '',
        row: {},
        types: [],
        supplierorg: [],
        projects: [],
        frequencys: [],
        typeOrg: [],
        orgcommunitys: [],
        alarmOrder: '' // 转让订单的信息
      }
    }
  },
  created () {
    this.golobleObject.getHandleInfo = this.changeShow
    this.golobleObject.updateTableAlarm = this.mqttHandle
    this.imgIconAlarm = this.getImgArr.getImgIconAlarm()
    this.imgIcon = this.getImgArr.getImgIconDevice()
    this.mqttHandleAlarm()
  },
  methods: {
    // 表格数据
    mqttHandleAlarm () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryunhanlealarm(params).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.alarms
        let oldDids = this.dids.length
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.dids.indexOf(this.tableData[i].did) === -1) {
            this.dids.push(this.tableData[i].did)
          }
        }
        if (oldDids === this.dids.length) {
          this.isDevice = false
        } else {
          this.isDevice = true
        }
        this.getDevices()
      }).catch(() => {
        this.loading = false
      })
    },
    // 设备
    getDevices () {
      if (this.isDevice) {
        let data = {
          dids: this.dids
        }
        querydevicebydids(data).then(res => {
          this.devices = this.devices.concat(res.data.devices)
          this.getDeviceTable()
        }).catch(() => {})
      } else {
        this.getDeviceTable()
      }
    },
    getDeviceTable () {
      const tempList = this.tableData
      this.tableData = []
      for (let i = 0; i < tempList.length; i++) {
        for (let j = 0; j < this.devices.length; j++) {
          if (tempList[i].did === this.devices[j].id) {
            tempList[i].device = this.devices[j]
          }
        }
      }
      this.tableData = tempList
      this.changeShow()
    },
    changeShow () {
      // console.log(999)
      this.showTable = []
      const handle = this.store2.state.other.isHandle
      let handleIDList = []
      for (let i = 0; i < handle.length; i++) {
        const arr = handle[i]
        if (handleIDList.indexOf(parseInt(arr.id)) === -1) {
          handleIDList.push(parseInt(arr.id))
        }
      }
      const tempList = this.tableData
      this.tableData = []
      for (let i = 0; i < tempList.length; i++) {
        const alarmObj = tempList[i]
        alarmObj.buttondisable = false
        alarmObj.handleuesrname = '未处理'
        if (alarmObj.prehandle > 0) {
          alarmObj.handleuesrname = '继续处理'
        }
        if (handleIDList.indexOf(alarmObj.id) > -1) {
          for (let ii = 0; ii < handle.length; ii++) {
            const usernameObj = handle[ii]
            if (usernameObj.id === alarmObj.id) {
              alarmObj.buttondisable = true
              alarmObj.handleuesrname = usernameObj.name + '正在处理'
            } else {
              alarmObj.buttondisable = false
            }
          }
        }
        this.tableData.push(alarmObj)
      }
      setTimeout(() => {
        this.showTable = this.tableData
      }, 50)
      this.$forceUpdate()
      // console.log('endlist', this.tableData)
    },
    // mqtt收到报警
    mqttHandle () {
      if (this.showTable.length === 1 && this.currentPage !== 1) {
        this.currentPage -= 1
      }
      this.mqttHandleAlarm()
    },
    getTypeImgAlarm (type) {
      let num = this.commonType.getAlarmTypeIcon(type)
      return this.imgIconAlarm[num].imgUrl
    },
    getAType (row) {
      return this.commonType.getAlarmType(row.alarmtype)
    },
    getTypeImg (type) {
      let url = this.imgIcon[0].imgUrl
      for (let i = 0; i < this.imgIcon.length; i++) {
        if (type === this.imgIcon[i].dtype) {
          url = this.imgIcon[i].imgUrl
        }
      }
      return url
    },
    getDeviceType (type) {
      if (type === 700) {
        return '智能网关'
      }
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else if (row.p_phone !== '') {
        return row.p_phone
      } else if (row.h_phone !== '') {
        return row.h_phone
      } else if (row.o_phone !== '') {
        return row.o_phone
      }
    },
    handleChangeNew (row) {
      let mqtts = this.$store.state.user.mqtts
      this.changeRow.alarmOrder = ''
      console.log(row)
      let name = this.$store.state.user.personname
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('yyyy-MM-dd hh:mm:ss')
      let jobnum = this.$store.state.user.syspersonjobnum
      let dohandle = {id: row.id, name: name, time: date, jobnum: jobnum}
      sendSub('/handlealarm' + mqtts[0], JSON.stringify(dohandle))
      if (row.alarmtype !== 'phonein') {
        this.changeRow.row = row
        this.handleAlarmShow = true
      } else {
        // console.log(11, this.changeRow)
        let obj = {
          alarmRow: row,
          types: this.changeRow.types,
          supplierorg: this.changeRow.supplierorg,
          typeOrg: this.changeRow.typeOrg,
          projects: this.changeRow.projects,
          orgcommunitys: this.changeRow.orgcommunitys
        }
        this.golobleObject.openPhoneCall(obj)
      }
    },
    getFatherHandle (obj) {
      if (obj.type === 'close') {
        this.handleAlarmShow = false
      } else if (obj.type === 'send') {
        this.mqttHandleAlarm()
        this.handleAlarmShow = false
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.mqttHandleAlarm()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.mqttHandleAlarm()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/dealAlarm.vue